import { useState, useEffect, useCallback } from 'react';
import { Link } from 'react-router-dom';
import { featuredArticles } from '@/mocks/articles';

export default function HeroBanner() {
  const [current, setCurrent] = useState(0);
  const total = featuredArticles.length;

  const goNext = useCallback(() => {
    setCurrent((prev) => (prev + 1) % total);
  }, [total]);

  useEffect(() => {
    const timer = setInterval(goNext, 5000);
    return () => clearInterval(timer);
  }, [goNext]);

  const article = featuredArticles[current] || featuredArticles[0];

  if (!article) return null;

  return (
    <section className="relative w-full h-[420px] md:h-[560px] overflow-hidden" aria-label="热点爆料轮播">
      {/* Background image */}
      <div className="absolute inset-0">
        <img
          src={article.imageUrl}
          alt={article.title}
          className="w-full h-full object-cover"
        />
      </div>

      {/* Dark overlay */}
      <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/20 to-black/70"></div>

      {/* Content */}
      <div className="absolute inset-0 flex items-end">
        <div className="w-full max-w-[1280px] mx-auto px-4 md:px-6 pb-12 md:pb-16">
          <div className="max-w-2xl">
            <div className="flex items-center gap-3 mb-4">
              <span className="px-3 py-1 rounded-full bg-accent-500 text-background-50 text-xs font-medium whitespace-nowrap">
                今日头条
              </span>
              <span className="text-background-50/80 text-sm">{article.category}</span>
              <span className="text-background-50/60 text-sm">{article.publishedAt}</span>
            </div>

            <Link to={`/article/${article.id}`} className="group">
              <h2 className="text-2xl md:text-4xl font-heading font-bold text-background-50 mb-3 leading-tight group-hover:text-accent-300 transition-colors duration-200">
                {article.title}
              </h2>
            </Link>

            <p className="text-background-50/80 text-sm md:text-base leading-relaxed mb-5 line-clamp-2">
              {article.excerpt}
            </p>

            <div className="flex items-center gap-4">
              <Link
                to={`/article/${article.id}`}
                className="inline-flex items-center gap-2 px-5 py-2.5 rounded-full bg-primary-500 text-background-50 text-sm font-medium hover:bg-primary-600 transition-colors duration-200 whitespace-nowrap cursor-pointer"
              >
                阅读全文
                <i className="ri-arrow-right-line"></i>
              </Link>
              <span className="text-background-50/60 text-sm">
                <i className="ri-eye-line mr-1"></i>
                {(article.views / 10000).toFixed(0)}万 阅读
              </span>
            </div>
          </div>
        </div>
      </div>

      {/* Navigation dots */}
      <div className="absolute bottom-6 right-6 md:right-10 flex items-center gap-2">
        {featuredArticles.map((_, idx) => (
          <button
            key={idx}
            onClick={() => setCurrent(idx)}
            className={`w-2.5 h-2.5 rounded-full transition-all duration-300 cursor-pointer ${
              idx === current ? 'bg-accent-500 w-8' : 'bg-background-50/50 hover:bg-background-50/80'
            }`}
            aria-label={`第${idx + 1}条`}
          />
        ))}
      </div>

      {/* Arrows */}
      <button
        onClick={() => setCurrent((prev) => (prev - 1 + total) % total)}
        className="absolute left-3 md:left-6 top-1/2 -translate-y-1/2 w-10 h-10 flex items-center justify-center rounded-full bg-background-50/20 hover:bg-background-50/40 text-background-50 transition-colors duration-200 cursor-pointer"
        aria-label="上一条"
      >
        <i className="ri-arrow-left-s-line text-xl"></i>
      </button>
      <button
        onClick={goNext}
        className="absolute right-3 md:right-6 top-1/2 -translate-y-1/2 w-10 h-10 flex items-center justify-center rounded-full bg-background-50/20 hover:bg-background-50/40 text-background-50 transition-colors duration-200 cursor-pointer"
        aria-label="下一条"
      >
        <i className="ri-arrow-right-s-line text-xl"></i>
      </button>
    </section>
  );
}